<template>
  <div>
    <v-dialog
      v-model="loading"
      persistent
      width="300"
    >
      <v-card height="190" class="text-center">
        <v-progress-circular
          :indeterminate="loading"
          :size="100"
          color="primary"
          class="mt-4 "
        >Loading...
        </v-progress-circular>
        <v-card-actions>
          <v-btn class="ml-auto my-2" color="primary" @click="loading=false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar color="success" v-model="snackbarSuccess">
      <v-list-item-title>
        <v-icon class="mr-2">mdi-check-circle-outline</v-icon>
        {{ snackbarSuccessText }}
      </v-list-item-title>
    </v-snackbar>

    <v-container>
      <v-btn
        variant="outlined"
        class="mr-4 mb-4"
        @click="clear"
      >クリア</v-btn>
      <v-btn
        variant="outlined"
        color="secondary"
        class="mr-4 mb-4"
        @click="generate"
      >生成</v-btn>
    </v-container>
    <v-form v-for="(prediction, index) in predictions" :key="index">
      <v-container class="my-0 py-0">
        <v-row>
          <v-col cols="4">
            <v-select
              v-model="prediction.categoryId"
              item-text="label"
              item-value="value"
              :items="categoryList"
              label="カテゴリー"
              @change="categoryChanged(index)"
            />
            <v-text-field
              v-model="prediction.predictionTitle"
              label="タイトル"
            />
            <v-file-input v-model="prediction.imageFile" label="画像を選択" @change="(file) => imageChanged(file, index)"></v-file-input>
            <v-textarea
              v-model="prediction.predictionBody"
              label="本文"
            ></v-textarea>
            <v-text-field
              v-model="prediction.link1"
              label="リンク１"
            />
            <v-text-field
              v-model="prediction.link2"
              label="リンク２"
            />
            <v-text-field
              v-model="prediction.link3"
              label="リンク３"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="prediction.choices[0]"
              label="選択肢１"
            />
            <v-text-field
              v-model="prediction.choices[1]"
              label="選択肢２"
            />
            <v-text-field
              v-model="prediction.choices[2]"
              label="選択肢３"
            />
            <v-text-field
              v-model="prediction.choices[3]"
              label="選択肢４"
            />
            <v-text-field
              v-model="prediction.choices[4]"
              label="選択肢５"
            />
            <v-row>
              <v-col cols="6">
                <v-dialog
                  v-model="prediction.closeDateDialog"
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="prediction.closeDate"
                      label="締切日"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="prediction.closeDate" @input="prediction.closeDateDialog = false; prediction.closeTimeDialog = true"></v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="6">
                <v-dialog
                  v-model="prediction.closeTimeDialog"
                  width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="prediction.closeTime"
                      label="締切時刻"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-time-picker 
                    v-model="prediction.closeTime" 
                    format="24hr"
                    active-picker="HOUR"
                    :allowed-minutes="allowedMinutes"
                    @click:hour="(hour) => setOpenMinute(hour, index)"
                  ></v-time-picker>
                </v-dialog>
              </v-col>
            </v-row>
            <v-select
              v-model="prediction.openPeriod"
              item-text="label"
              item-value="value"
              :items="openPeriodList"
              label="開催期間"
            />
            <v-select
              v-model="prediction.finalizeAfter"
              item-text="label"
              item-value="value"
              :items="finalizeAfterList"
              label="結果確定時間"
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="prediction.choices[5]"
              label="選択肢６"
            />
            <v-text-field
              v-model="prediction.choices[6]"
              label="選択肢７"
            />
            <v-text-field
              v-model="prediction.choices[7]"
              label="選択肢８"
            />
            <v-text-field
              v-model="prediction.choices[8]"
              label="選択肢９"
            />
            <v-text-field
              v-model="prediction.choices[9]"
              label="選択肢１０"
            />
            <p class="text-right">
              <v-btn
                color="primary"
                @click="submit(index)"
              >作成</v-btn>
            </p>
            <v-img :src="prediction.imageUrl"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
  import axios from "axios"
  import moment from 'moment'
  import mixin from '@/util/mixin'

  export default {
    mixins: [mixin],
    data () {
      return {
        predictionTemplate: {
          categoryId: undefined,
          predictionTitle: undefined,
          imageFile: undefined,
          predictionBody: undefined,
          link1: undefined,
          link2: undefined,
          link3: undefined,
          choices: [
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
          ],
          closeDate: undefined,
          closeDateDialog: false,
          closeTime: undefined,
          closeTimeDialog: false,
          openPeriod: 1,
          finalizeAfter: 24,
          creatorReward: 0.0,
          correctReporterReward: 25,
          imageUrl: '',
        },
        predictions: [],
        snackbarSuccess: false,
        snackbarSuccessText: '',
        categoryList: [
        {
            label: '野球',
            value: '20',
          },
          {
            label: 'サッカー',
            value: '30',
          },
          {
            label: 'その他スポーツ',
            value: '40',
          },
          {
            label: 'エンタメ',
            value: '50',
          },
          {
            label: '政治・経済',
            value: '60',
          },
        ],
        allowedMinutes: [0],
        openPeriodList: [...Array(7)].map((_, i) => ({label: `${i + 1}日間`, value: i + 1})),
        finalizeAfterList: [...Array(24)].map((_, i) => ({label: `${i + 1}時間後`, value: i + 1})),
        creatorRewardList: [...Array(20)].map((_, i) => ({label: `${i * 0.5}%`, value: i * 0.5})),
        correctReporterRewardList: [...Array(25)].map((_, i) => ({label: `${i + 1}%`, value: i + 1})),
        openai: undefined,
        loading: false,
      }
    },
    methods: {
      setOpenMinute (hour, index) {
        console.log(hour, index)
        this.predictions[index].closeTime = hour < 10 ? `0${hour}:00` : `${hour}:00`
        this.predictions[index].closeTimeDialog = false
      },
      async generate () {
        const system_prompt = `
          ### 前提
          あなたは日本で流行している未来予想ゲームの予想問題を作成するアシスタントです。
          与えられた年月日に対して、その日に実際に起きる出来事のうち結果を予想する問題が作成可能な出来事の詳細をインターネットで検索してください。
          その出来事について結果がどうなるかを予想する問題を作成してください。
          予想問題には出典元のURLを記載してください。
          また回答は選択式とし、必ずどれか1つが正解となる選択肢を提示してください。
          与えられた年月日に起きる出来事を予想するのではなく、特定の出来事が起きた結果がどうなるかを予想する問題を作成してください。
        `

        const prediction = `
          ### 質問
          ${new Date(new Date().setDate(new Date().getDate() + 2)).toLocaleDateString('ja-JP')}に日本で起きる出来事について予想問題を作成してください。
          ### 出力形式
          JSON形式
          ### テンプレート
          {
            "predictions": [
              {
                "prediction_title": "ここに予想問題のタイトル",
                "prediction_body": "ここに予想問題の本文",
                "url": "ここに出典元のURL",
                "choices": [
                  {"no": 1, "choice": "ここに1個目の選択肢"},
                  {"no": 2, "choice": "ここに2個目の選択肢"},
                  ・・・
                  {"no": N, "choice": "ここにN個目の選択肢"}
                ]
              }
            ]
          }
        `
        const payload = {
          messages: [
            { role: "system", content: system_prompt },
            { role: "user", content: JSON.stringify(prediction) },
          ],
          model: "sonar-pro",
          web_search_options: {
            search_context_size: "medium"
          }
        }
        const instance = axios.create({
          baseURL: "https://api.perplexity.ai",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${process.env.VUE_APP_PPLX_API_KEY}`
          },
        })
        this.loading = true
        instance.post('/chat/completions', payload)
        .then((response) => {
          console.log(response)
          this.loading = false
          const content = response.data.choices[0].message.content
          const fromIndex = content.indexOf('{')
          const toIndex = content.lastIndexOf('}') + 1
          const json = JSON.parse(content.substring(fromIndex, toIndex))
          this.predictions.splice(0, this.predictions.length)
          for (let i = 0; i < json.predictions.length; i++) {
            const prediction = json.predictions[i]
            this.predictions.push(JSON.parse(JSON.stringify(this.predictionTemplate)))
            this.predictions[i].predictionTitle = prediction.prediction_title
            this.predictions[i].predictionBody = prediction.prediction_body
            this.predictions[i].link1 = prediction.url
            prediction.choices.forEach((choice, index) => {
              this.predictions[i].choices[index] = choice.choice          
            });
          }
        })
        .catch((error) => {
          console.log(error)
          this.loading = false
        })
      },
      clear () {
        this.predictions.splice(0, this.predictions.length)
        this.predictions.push({...this.predictionTemplate, choices: [...this.predictionTemplate.choices]})
      },
      submit (index) {
        const db = this.$fb.firestore
        const batch = this.$fb.writeBatch(db)
        const now = new Date()
        const predictionId = `A${now.getTime()}`
        const creatorId = 'iPCkxpyyA2Tytx2guNxev7yTd132'
        const hour = parseInt(this.predictions[index].closeTime.split(':')[0], 10)
        const closeAt = new Date(new Date(this.predictions[index].closeDate).setHours(hour, 0, 0, 0))
        const openAt = new Date(new Date(closeAt.getTime()).setDate(closeAt.getDate() - this.predictions[index].openPeriod))
        const reportingTo = new Date(new Date(closeAt.getTime()).setHours(closeAt.getHours() + this.predictions[index].finalizeAfter, 0, 0, 0))

        const defaultImagePath = this.getDefaultImagePath(this.predictions[index].imageFile.name)
        const imagePath = !this.predictions[index].imageFile 
          ? ''
          : defaultImagePath
          ? defaultImagePath
          : `images/predictions/${creatorId}/${predictionId}.png`
        if (imagePath && this.predictions[index].imageFile.name.includes('.')) {
          const imageRef = this.$fb.ref(this.$fb.storage, imagePath)
          this.$fb.uploadBytesResumable(imageRef, this.predictions[index].imageFile)
        }

        const predictionRef = this.$fb.doc(this.$fb.firestore, 'prediction', predictionId)
        batch.set(predictionRef, {
          created_at: new Date(),
          updated_at: new Date(),
          creator_id: creatorId,
          category_id: this.predictions[index].categoryId,
          prediction_title: this.predictions[index].predictionTitle,
          image_path: imagePath,
          prediction_body: this.predictions[index].predictionBody,
          link1: this.predictions[index].link1 || '',
          link2: this.predictions[index].link2 || '',
          link3: this.predictions[index].link3 || '',
          open_at: openAt,
          close_at: closeAt,
          reporting_from: closeAt,
          reporting_to: reportingTo,
          index: this.bigram(this.predictions[index].predictionTitle),
          creator_reward_rate: this.predictions[index].creatorReward,
          reporter_reward_rate: this.predictions[index].correctReporterReward,
          is_published: false,
          answer_count: 0,
          comment_count: 0,
          is_finalized: false,
          is_invalid: false,
          is_second: false,
        })
        let i = 1
        for (const choice of this.predictions[index].choices) {
          if (!choice) continue
          const choiceRef = this.$fb.doc(this.$fb.firestore, 'prediction', predictionId, 'choice', String(i))
          batch.set(choiceRef, {
            choice: choice,
            answer_count: 0,
            odds: 1.0,
            report_count: 0,
            second_report_count: 0,        
          })
          i++
        }
        batch.commit().then(() => {
          this.snackbarSuccessText = '予想問題を作成しました。'
          this.snackbarSuccess = true
          if (this.predictions.length === 1) {
            this.clear()
          } else {
            this.predictions.splice(index, 1)
          }
        })
      },
      categoryChanged (index) {
        let imageFileName = ''
        switch (this.predictions[index].categoryId) {
          case '20':
            imageFileName = 'baseball'
            break
          case '30':
            imageFileName = 'soccer'
            break
          case '40':
            imageFileName = 'fighting'
            break
          case '50':
            imageFileName = 'single'
            break
          case '60':
            imageFileName = 'economics'
            break
        }
        this.predictions[index].imageFile = {name: imageFileName}
        this.setImageUrl(imageFileName, index)
      },
      imageChanged (file, index) {
        console.log(file)
        if (file !== undefined && file !== null) {
          if (file.name.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(file)
          fr.addEventListener('load', () => {
            this.predictions[index].imageUrl = fr.result
          })
        } else {
          this.predictions[index].imageUrl = ''
        }
      },
      getDefaultImagePath (imageFileName) {
        switch (imageFileName) {
          case 'baseball':
            return 'images/predictions/m5OmEeLifqc8HOEmQ1ly4aiW3As1/A1707311042912.png'
          case 'soccer':
            return 'images/predictions/m5OmEeLifqc8HOEmQ1ly4aiW3As1/A1707384128200.png'
          case 'fighting':
            return 'images/predictions/iPCkxpyyA2Tytx2guNxev7yTd132/A1714783064945.png'
          case 'single':
            return 'images/predictions/m5OmEeLifqc8HOEmQ1ly4aiW3As1/A1707292760133.png'
          case 'economics':
            return 'images/predictions/m5OmEeLifqc8HOEmQ1ly4aiW3As1/A1707477992898.png'
          default:
            return ''
        }
      },
      async setImageUrl (imageFileName, index) {
        const imagePath = this.getDefaultImagePath(imageFileName)
        if (imagePath) {
          const imageRef = this.$fb.ref(this.$fb.storage, imagePath)
          this.predictions[index].imageUrl = await this.$fb.getDownloadURL(imageRef)
        } else {
          this.predictions[index].imageUrl = ''
        }
      },
    },
    created () {
      moment.locale('ja')
      this.clear()
    }
  }
</script>